export const getMenuData = [
  // DASHBOARD MODULE
  {
    category: true,
    title: 'Dashboard',
  },
  {
    title: 'Dashboard',
    key: 'dashboard',
    url: '/dashboard',
    icon: 'fe fe-layout',
    roles: ['superadmin', 'admin', 'employee'],
  },
  // CRM MODULE
  {
    category: true,
    title: 'CRM',
  },
  {
    title: 'Quick Search',
    key: 'crm.quick-search',
    url: '/crm/quick-search',
    icon: 'fe fe-search',
    roles: ['superadmin', 'admin', 'employee'],
  },
  {
    title: 'Customers',
    count: 0,
    key: 'crm.customers',
    url: '/crm/customers',
    icon: 'fe fe-users',
    roles: ['superadmin', 'admin', 'employee'],
  },
  // PM MODULE
  {
    category: true,
    title: 'PM',
  },
  {
    title: 'Projects',
    count: 0,
    key: 'pm.projects',
    url: '/pm/projects',
    icon: 'fe fe-list',
    roles: ['superadmin', 'admin', 'employee'],
  },
  {
    title: 'Contracts',
    count: 0,
    key: 'pm.contracts',
    url: '/pm/contracts',
    icon: 'fe fe-file-text',
    roles: ['superadmin', 'admin', 'employee'],
  },
  {
    title: 'Tasks List',
    count: 0,
    key: 'pm.tasks',
    url: '/pm/tasks',
    icon: 'fe fe-list',
    roles: ['superadmin', 'admin', 'employee'],
  },
  {
    title: 'Teams List',
    count: 0,
    key: 'pm.teams',
    url: '/pm/teams',
    icon: 'fe fe-list',
    roles: ['superadmin', 'admin', 'employee'],
  },
  // MARKETING MODULE
  {
    category: true,
    title: 'Marketing',
  },
  {
    title: 'Recipients',
    count: 0,
    key: 'marketing.recipients',
    url: '/marketing/recipients',
    icon: 'fe fe-users',
    roles: ['superadmin', 'admin', 'employee'],
  },
  {
    title: 'Campaigns',
    count: 0,
    key: 'marketing.campaigns',
    url: '/marketing/campaigns',
    icon: 'fe fe-crosshair',
    roles: ['superadmin', 'admin', 'employee'],
  },
  // {
  //   title: 'Notification',
  //   count: 0,
  //   key: 'marketing.notification',
  //   url: '/marketing/notification',
  //   icon: 'fe fe-bell',
  //   roles: ['superadmin', 'admin', 'employee'],
  // },

  // SYSTEM MODULE
  {
    category: true,
    title: 'System',
  },
  // {
  //   title: 'Settings',
  //   count: 0,
  //   key: 'system.settings',
  //   url: '/system/settings',
  //   icon: 'fe fe-settings',
  //   roles: ['superadmin', 'admin', 'employee'],
  // },
  {
    title: 'Staffs',
    count: 0,
    key: 'system.staffs',
    url: '/system/staffs',
    icon: 'fe fe-users',
    roles: ['superadmin', 'admin', 'employee'],
  },
  // ADMIN MODULE
  {
    category: true,
    title: 'Admin(Internal)',
  },
  {
    title: 'Contractors',
    count: 0,
    key: 'admin.contractors',
    url: '/admin/contractors',
    icon: 'fe fe-home',
    roles: ['superadmin'],
  },
  {
    title: 'System Users',
    count: 0,
    key: 'admin.users',
    url: '/admin/users',
    icon: 'fe fe-users',
    roles: ['superadmin'],
  },
]
